export default "__VITE_ASSET__p3E790rw__"